<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="knw_message_body knw_media" :class="[getMessageSender]">
    <VideoPlayer v-if="mediaType === 'video'" :media-url="message.data.mediaUrl" :label="message.data?.media?.alt" />
    <YouTubeEmbedd v-if="mediaType === 'youtube'" :youtube-url="message.data.mediaUrl" />
    <ImageElement
      v-if="mediaType === 'image'"
      :src="message.data.mediaUrl"
      :alt="message.data?.media?.alt"
      :aspect-ratio="`${message.data?.media?.width} / ${message.data?.media?.height}`"
    />
  </div>
</template>

<script setup lang="ts">
import VideoPlayer from '@/components/media/VideoPlayer.vue';
import YouTubeEmbedd from '@/components/media/YouTubeEmbedd.vue';
import ImageElement from '@/components/media/ImageElement.vue';


import { computed } from 'vue';
import type { Media } from '@/services/bot/messageBuilder';


const props = defineProps<{
  message: Media
}>();

const getMessageSender = computed(() => `sender_${props.message.source || 'bot'}`);

const mediaType = computed(() => props.message.data.mediaType);

</script>

<style lang="scss" scoped>
.knw_message_body {
  display: flex;
  margin-bottom: 5px;
  position: relative;
  max-width: 80%;

  &.sender_user {
    justify-self: end;
  }

  &.sender_bot,
  .sender_agent,
  .sender_system {
    justify-self: start;
  }
}
</style>
